"use client";

// src/blur-fade.tsx
import {
  AnimatePresence,
  motion,
  useInView
} from "motion/react";
import { useRef } from "react";
import { jsx } from "react/jsx-runtime";
var BlurFade = (props) => {
  const {
    children,
    className,
    variant,
    duration = 0.4,
    delay = 0,
    yOffset = 6,
    inView = false,
    inViewMargin = "-50px",
    blur = "6px"
  } = props;
  const ref = useRef(null);
  const inViewResult = useInView(ref, { once: true, margin: inViewMargin });
  const isInView = !inView || inViewResult;
  const defaultVariants = {
    hidden: { y: yOffset, opacity: 0, filter: `blur(${blur})` },
    visible: { y: -yOffset, opacity: 1, filter: `blur(0px)` }
  };
  const combinedVariants = variant ?? defaultVariants;
  return /* @__PURE__ */ jsx(AnimatePresence, { children: /* @__PURE__ */ jsx(
    motion.div,
    {
      ref,
      initial: "hidden",
      animate: isInView ? "visible" : "hidden",
      exit: "hidden",
      variants: combinedVariants,
      transition: {
        delay: 0.04 + delay,
        duration,
        ease: "easeOut"
      },
      className,
      children
    }
  ) });
};

export {
  BlurFade
};
